<template>
    <div class="account-edit-modal">
        <TitleBaseBox :title="title" @close="close" @confirm="confirmClick" @cancel="cancelClick">
            <div class="account-info-list">
                <AddDataPanel :label="nameLabel">
                    <div class="name-edit-content">
                        <IconInput class="group-name-input" :initValue="initName" @inputChange="nameChange" :placeholder="inputNameLabel" />
                        <div class="work-group">
                            <Checkbox name="workCheck" class="work-check" @valueChange="workCheckHandler" :data="workCheck.checked" />
                            <span :class="{ 'english-lable': $i18n.locale != 'cn' }">{{
                                $t("zhiji.personnel.groupManage.groupEditModal.workGroup")
                            }}</span>
                            <div class="max-num-input">
                                <div :class="{ 'text-label': $i18n.locale != 'cn' }">
                                    {{ $t("zhiji.personnel.groupManage.groupEditModal.maxWorkGroupTip") }}
                                </div>
                                <IconInput class="max-work-input" :initValue="workCheck.maxWork" @inputChange="maxWorkChange" />
                            </div>
                        </div>
                        <!--div class="work-group">
                            <Checkbox name="workCheck" class="work-check" @valueChange="chatCheckHandler" :data="chatCheck.checked" />
                            <span :class="{ 'english-lable': $i18n.locale != 'cn' }">{{
                                $t("zhiji.personnel.groupManage.groupEditModal.chatGroup")
                            }}</span>
                            <div class="max-num-input">
                                <div :class="{ 'text-label': $i18n.locale != 'cn' }">
                                    {{ $t("zhiji.personnel.groupManage.groupEditModal.maxChatGroupTip") }}
                                </div>
                                <IconInput class="max-work-input" :initValue="chatCheck.maxChat" @inputChange="maxChatChange" />
                            </div>
                        </div-->
                    </div>
                </AddDataPanel>
                <AddDataPanel :label="languageLabel">
                    <Select :initValue="languageInit" :options="languageOptions" class="language-select" @menuClick="languageSelect" />
                </AddDataPanel>
                <AddDataPanel :label="tagLabel" class="select-box">
                    <Select
                        class="tag-select"
                        :config="{ initLabel: data.tagName || initTagLabel }"
                        :initValue="initTagId"
                        :topOrBottom="86"
                        :options="tagTypeOption"
                        @menuClick="tagSelected"
                    >
                        <Search :placeholder="tagSelectedLabel" @searchChange="searchChange" @inputChange="searchChange" class="tag-search" />
                    </Select>
                </AddDataPanel>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import IconInput from "@/views/zhiji/bComponents/inputs/IconInput";
import Checkbox from "@/views/zhiji/bComponents/checks/Checkbox";
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import AddDataPanel from "../AddDataPanel";
import Select from "@/views/zhiji/bComponents/inputs/Select";
import Search from "@/views/zhiji/bComponents/inputs/Search";

import { languageOptions, groupTypes } from "../../personConfig.js";
import i18n from "@/i18n";

export default {
    name: "GroupEditModal",
    props: ["data"],
    components: {
        TitleBaseBox,
        AddDataPanel,
        Select,
        IconInput,
        Checkbox,
        Search
    },
    data() {
        return {
            initName: (this.data.addData && this.data.addData.groupName) || "",
            workCheck: {
                checked: this.data.addData && this.data.addData.doMax ? true : false,
                maxWork: (this.data.addData && this.data.addData.doMax) || ""
            },
            chatCheck: {
                checked: this.data.addData && this.data.addData.chatMax ? true : false,
                maxChat: (this.data.addData && this.data.addData.chatMax) || ""
            },
            tagId: "",
            language: this.data ? this.data.addData.language : "en"
        };
    },
    computed: {
        languageInit() {
            return this.data ? this.data.addData.language : "en";
        },
        initTagId() {
            return this.data ? this.data.addData.tagId : "def";
        },
        initTagLabel() {
            return this.$t("zhiji.form.selectTabLabel");
        },
        tagLabel() {
            return this.$t("zhiji.form.tag");
        },
        tagSelectedLabel() {
            return this.$t("zhiji.form.serchTagLabel");
        },
        languageOptions() {
            return languageOptions();
        },
        nameLabel() {
            return this.$t("zhiji.personnel.groupManage.tabelCloumn.groupName");
        },
        inputNameLabel() {
            return this.$t("zhiji.personnel.groupManage.groupEditModal.inputHolderTip");
        },
        languageLabel() {
            return this.$t("zhiji.personnel.language");
        },
        title() {
            return this.data
                ? this.$t("zhiji.personnel.groupManage.groupEditModal.editGroupLabel")
                : this.$t("zhiji.personnel.groupManage.groupEditModal.addGroupLabel");
        },
        tagTypeOption() {
            return this.getStorePorp("groupTagDatas");
        }
    },
    mounted() {
        if (this.data && this.data.addData.tagId) {
            this.tagId = this.data.addData.tagId;
        }
        this.$store.dispatch("zhiji/getGroupTagTreesData");
    },
    methods: {
        close() {
            this.$emit("closeModal");
        },
        cancelClick() {
            this.close();
        },
        confirmClick() {
            let checkedData = {
                groupName: this.initName,
                workCheck: this.workCheck,
                chatCheck: this.chatCheck,
                tagId: this.tagId
            };
            // eslint-disable-next-line
            checkGroupData(checkedData) ? this.showErrorTips(checkGroupData(checkedData))
                : this.saveGroupEdit();
        },
        showErrorTips(errMessage) {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "error",
                    message: errMessage
                }
            });
        },
        saveGroupEdit() {
            let requst = {
                tagId: this.tagId,
                groupName: this.initName,
                language: this.language,
                onlineMax: this.chatCheck.maxChat,
                dayMax: this.workCheck.maxWork,
                groupType: this.getGroupSetting()
            };
            let requstUrl = "";
            if (this.data) {
                requstUrl = "updateGroupEdit";
                requst.groupId = this.data.rowId;
            } else {
                requstUrl = "saveGroupEdit";
            }
            this.zhiji.requestByServiceName(requstUrl, requst).then(() => {
                this.$store.dispatch("zhiji/queryGroupList", {});
                this.$store.commit("zhiji/clearGroupOption");
                this.close();
            });
        },
        getGroupSetting() {
            if (this.workCheck.checked && this.chatCheck.checked) {
                return groupTypes.allGroupChecked;
            } else if (this.workCheck.checked && !this.chatCheck.checked) {
                return groupTypes.workChecked;
            } else if (!this.workCheck.checked && this.chatCheck.checked) {
                return groupTypes.chatChecked;
            } else if (!this.workCheck.checked && !this.chatCheck.checked) {
                return groupTypes.noChecked;
            }
        },
        nameChange(data) {
            this.initName = data;
        },
        workCheckHandler(data) {
            this.workCheck.checked = data.checked;
        },
        chatCheckHandler(data) {
            this.chatCheck.checked = data.checked;
        },
        maxWorkChange(data) {
            this.workCheck.maxWork = data;
            this.workCheck.maxWork ? (this.workCheck.checked = true) : (this.workCheck.checked = false);
        },
        getStorePorp(propName) {
            return this.$store.state.zhiji.personnelManage[propName];
        },
        maxChatChange(data) {
            data ? (this.chatCheck.checked = true) : (this.chatCheck.checked = false);
            this.chatCheck.maxChat = data;
        },
        languageSelect(data) {
            this.language = data.value;
        },
        tagSelected(data) {
            this.$store.commit("zhiji/searchGroupTagScenes", {
                field: ""
            });
            this.tagId = data.value;
        },
        searchChange(data) {
            this.$store.commit("zhiji/searchGroupTagScenes", {
                field: data.value
            });
        }
    }
};

// 校验编辑项
function checkGroupData(data) {
    if (!data.groupName) {
        return i18n.t("zhiji.personnel.groupManage.groupEditModal.checkNameTips");
    }

    if (data.workCheck.checked && !data.workCheck.maxWork) {
        return i18n.t("zhiji.personnel.groupManage.groupEditModal.checkMaxWorkTips");
    }

    if (data.chatCheck.checked && !data.chatCheck.maxChat) {
        return i18n.t("zhiji.personnel.groupManage.groupEditModal.checkMaxChatTips");
    }

    if (!data.tagId || data.tagId === "def") {
        return "请选择关联标签";
    }
}
</script>

<style lang="less" scoped>
.account-edit-modal {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;

    .account-info-list {
        font-size: 12px;

        .group-name-input {
            width: 400px;
            border: 1px solid #d8e4f0;
            border-radius: 4px;
        }
    }

    .work-group {
        display: flex;
        margin-top: 16px;
        height: 40px;
        line-height: 40px;

        .english-lable {
            width: 134px;
        }

        .work-check {
            margin-right: 5px;
        }

        .max-num-input {
            min-width: 300px;
            display: flex;
            margin-left: 20px;

            .text-label {
                width: 251px;
                text-align: right;
                padding-right: 5px;
            }

            .max-work-input {
                width: 100px;
                border: 1px solid #d8e4f0;
                height: 32px;
                margin-top: 4px;
                box-sizing: border-box;
                border-radius: 4px;
                input {
                    vertical-align: top;
                }
            }
        }
    }

    .select-box {
        position: relative;
        .tag-select {
            width: 315px;
            color: #9b9ba3;
            background: #fff;

            .tag-search {
                padding: 7px 0 7px;
                width: 100%;
                position: absolute;
                left: 0;
                top: 42px;
                background: #fff;
                z-index: 1;
            }
        }
    }
}
</style>
